import {Stack} from '@mui/material';
import {findIndex} from 'lodash';
import {FC, useMemo} from 'react';
import {Controller} from 'react-hook-form';
import {SwitchField} from '../../../../../../../ui/switch-field';
import {useStepsFormContext} from '../../contexts';
import {useStepperStore} from '../../store/useStepperStore';

export const Header: FC = () => {
  const id = useStepperStore((s) => s.selectedStepId);
  const {control, watch} = useStepsFormContext();
  const steps = watch('steps');
  const activeStepIndex = useMemo(() => findIndex(steps, {id: String(id)}), [steps, id]);

  return (
    <Stack gap={2} width="100%" pt="22px">
      <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
        <Controller
          name={`steps.${activeStepIndex}.editModeOnly`}
          control={control}
          render={({field}) => (
            <SwitchField
              label="Включать только в режиме доработки"
              checked={field.value}
              onChange={field.onChange}
              labelColor="#FF5E5ECC"
            />
          )}
        />
        <Controller
          name={`steps.${activeStepIndex}.saveOnComplete`}
          control={control}
          render={({field}) => (
            <SwitchField
              label="Сохранять данные при завершении шага"
              checked={field.value}
              onChange={field.onChange}
              labelColor="#FF5E5ECC"
            />
          )}
        />
      </Stack>
    </Stack>
  );
};
